export default __webpack_public_path__ + "static/media/laptop.e43a8ecc.jpg";